module.exports = __webpack_public_path__ + "media/images/new_culture/bg-13-151a9b2a980643330e3bf08941ae85bb.png";